import { TextField } from "@mui/material";

interface OverviewFilterFieldProps {
    setFilter: (filter: string) => void;
    label?: string
    disabled?: boolean;
}

export const OverviewFilterField = (props: OverviewFilterFieldProps) => {
  return (
    <TextField
      id="standard-search"
      label={props.label ?? "Filtr..."}
      type="search"
      variant="standard"
      disabled={props.disabled ?? false}
      onChange={(e) => {
        props.setFilter(e.target.value)}}
      sx={{
        marginBottom: "0.5rem",
      }}
    />
  );
};
